import React from 'react'
import {
    Box,
    Typography,
    Button,
    Paper,
    TextField,
    Autocomplete,
    FormControlLabel,
    RadioGroup,
    Radio,
} from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
const labelStyle = {
    marginBottom: '4px',
    fontWeight: 500,
    color: '#1A1F36',
    fontSize: '14px',
};

const inputStyle = {
    height: '40px',
    backgroundColor: '#fff',
    fontSize: '13px',
    color: '#1A1F36',
};

const countries = ['India', 'United States', 'Canada', 'Australia'];
const states = ['Delhi', 'Maharashtra', 'Karnataka', 'California', 'New York'];
const categories = ['IT Services', 'Consulting', 'Education', 'Healthcare'];
const SubscriptionForm = () => {
    const [country, setCountry] = useState(null);
    const [state, setState] = useState(null);
    const [category, setCategory] = useState(null);
    const [taxType, setTaxType] = useState(null);
    const [emailSetting, setEmailSetting] = useState("default");

    const theme = useTheme();

    return (
        <>
            {/* ---------- Invoice Customization Section ---------- */}
            <Paper sx={{ p: 3, mb: 3, borderRadius: '8px', border: '1px solid #E5E7EB' }}>
                <Typography variant="h6" fontWeight="600" color="#1A1F36" sx={{ fontSize: { xl: '18px !important', lg: '17px !important', md: '16px !important', sm: '16px !important', xs: '15px !important' } }}>
                    Customize Invoice
                </Typography>
                <Typography sx={{ fontSize: '13px', color: '#555', mb: 3 }}>
                    Personalize the invoice format sent from TimeTrackr to your company
                </Typography>
                <Grid container spacing={2}>
                    {/* Bill to Address */}
                    <Grid item xs={12}>
                        <Typography sx={labelStyle}>Bill to Address</Typography>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Typography sx={labelStyle}>Country*</Typography>
                        <Autocomplete
                            options={countries}
                            value={country}
                            onChange={(e, newValue) => setCountry(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Country"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, sx: inputStyle }}
                                />
                            )}
                            slotProps={{
                                paper: {
                                    sx: { fontSize: '13px' }, // dropdown font size
                                },
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={12} sm={6}>
                        <Typography sx={labelStyle}>Address Line 1*</Typography>
                        <TextField
                            fullWidth
                            placeholder="Street Address"
                            variant="outlined"
                            InputProps={{ sx: inputStyle }}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} sm={6}>
                        <Typography sx={labelStyle}>Address Line 2*</Typography>
                        <TextField
                            fullWidth
                            placeholder="Street Address"
                            variant="outlined"
                            InputProps={{ sx: inputStyle }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={4}>
                        <Typography sx={labelStyle}>City*</Typography>
                        <TextField
                            fullWidth
                            placeholder="City"
                            variant="outlined"
                            InputProps={{ sx: inputStyle }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={4}>
                        <Typography sx={labelStyle}>State*</Typography>
                        <Autocomplete
                            options={states}
                            value={state}
                            onChange={(e, newValue) => setState(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select State"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, sx: inputStyle }}
                                />
                            )}
                            slotProps={{
                                paper: {
                                    sx: { fontSize: '13px' }, // dropdown font size
                                },
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={12} sm={6} lg={4}>
                        <Typography sx={labelStyle}>Zip Code*</Typography>
                        <TextField
                            fullWidth
                            placeholder="Zip Code"
                            variant="outlined"
                            InputProps={{ sx: inputStyle }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} sm={6}>
                        <Typography sx={labelStyle}>Phone Number*</Typography>
                        <TextField
                            fullWidth
                            placeholder="Phone Number"
                            variant="outlined"
                            InputProps={{ sx: inputStyle }}
                        />
                    </Grid>

                    {/* Category */}
                    <Grid item xs={12} md={6}>
                        <Typography sx={labelStyle}>Select Category*</Typography>
                        <Autocomplete
                            options={categories}
                            value={category}
                            onChange={(e, newValue) => setCategory(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Category"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, sx: inputStyle }}
                                />
                            )}
                            slotProps={{
                                paper: {
                                    sx: { fontSize: '13px' }, // dropdown font size
                                },
                            }}
                        />
                    </Grid>

                    {/* Tax ID */}
                    <Grid item xs={12} md={6} sm={6}>
                        <Typography sx={labelStyle}>Tax ID Type*</Typography>
                        <Autocomplete
                            options={['GSTIN', 'PAN', 'VAT']}
                            value={taxType}
                            onChange={(e, newValue) => setTaxType(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Tax Type"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, sx: inputStyle }}
                                />
                            )}
                            slotProps={{
                                paper: {
                                    sx: { fontSize: '13px' }, // dropdown font size
                                },
                            }}

                        />
                    </Grid>

                    <Grid item xs={12} md={6} sm={6}>
                        <Typography sx={labelStyle}>Your Tax ID*</Typography>
                        <TextField
                            fullWidth
                            placeholder="Enter Tax ID"
                            variant="outlined"
                            InputProps={{ sx: inputStyle }}
                        />
                    </Grid>

                    {/* Notes */}
                    <Grid item xs={12}>
                        <Typography sx={labelStyle}>Notes</Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            placeholder="Additional notes"
                            variant="outlined"
                            InputProps={{
                                sx: {
                                    fontSize: '13px',
                                    '& input::placeholder': {
                                        fontSize: '12px !important',
                                        color: '#888' // optional
                                    },
                                    '& textarea::placeholder': {
                                        fontSize: '12px!important',
                                        color: '#888' // optional
                                    }
                                }
                            }}
                        />
                    </Grid>

                    {/* Email Notification Settings */}
                    <Grid item xs={12}>
                        <Typography variant="h6" fontWeight="600" color="#1A1F36" sx={{ fontSize: { xl: '18px !important', lg: '17px !important', md: '16px !important', sm: '16px !important', xs: '15px !important' } }}>
                            Email Notification Settings
                        </Typography>
                        <Typography sx={{ fontSize: '13px', color: '#555', mb: 3 }}>
                            Personalize the invoice format sent from TimeTrackr to your company
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography sx={labelStyle}>Default</Typography>
                            <RadioGroup
                                row
                                value={emailSetting}
                                onChange={(e) => setEmailSetting(e.target.value)}
                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '13px',   // 👈 yahan se sab label ka font size change ho jayega
                                    },
                                }}
                            >
                                <FormControlLabel value="off" control={<Radio />} label="Off" />
                                <FormControlLabel value="owners" control={<Radio />} label="All Owners" />
                                <FormControlLabel value="custom" control={<Radio />} label="Custom" />
                            </RadioGroup>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 2,
                                pt: 2,
                            }}
                        >
                            <Button
                                variant="outlined"
                                sx={{ borderRadius: '50px', textTransform: 'none', px: 3 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    borderRadius: '50px',
                                    textTransform: 'none',
                                    px: 3,
                                    backgroundColor: '#0076FE',
                                }}
                            >
                                Save
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export default SubscriptionForm
